
export class ObjectFactory {

	static create<T>(defaults: T, partial?: Partial<T> | null): T {
		return this.merge(defaults, partial);
	}

	private static merge<T>(defaults: T, partial?: Partial<T> | null): T {
		if (!partial) return { ...defaults };

		const result: any = { ...defaults };

		Object.keys(partial).forEach(key => {
			const value = (partial as any)[key];

			if (value !== null && typeof value === 'object' && !(value instanceof Date) && !Array.isArray(value)) {
				result[key] = this.merge((defaults as any)[key] || {}, value);
			} else {
				result[key] = value;
			}
		});

		return result;
	}

}
